import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Http, Response, URLSearchParams, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

import { TdIssuesModel } from './td-issues.model';

declare var ajaxurl:any;

@Injectable()
export class TdIssuesService {
  currentIssue:Subject<any> = new BehaviorSubject<any>(new TdIssuesModel(null));

  constructor(private http:Http) {
  }

  setCurrentIssue(newIssue:any, isError:Boolean):void {
    let sendStream = {
      newIssue: newIssue,
      isError: isError
    };
    this.currentIssue.next(sendStream);
  }

  getCurrentUser() {
    let params:URLSearchParams = new URLSearchParams();
    params.set('action', 'get_current_user');

    return this.http
      .get(ajaxurl, {
        search: params
      })
      .map((res:Response) => res.json());
  }

  postSendIssue(issue:TdIssuesModel) {
    return this.http
      .post('http://localhost:3000/api/issues', issue, this.getTokenPostOptions())
      .map((res:Response) => res.json());
  }

  postSendIssueByEmail(issue:TdIssuesModel) {
    let params:URLSearchParams = new URLSearchParams();

    params.set('issue', JSON.stringify(issue));

    return this.http
      .post(`${ajaxurl}?action=post_issue_email`, params, this.getTokenPostOptions())
      .map((res:Response) => res.json());
  }

  /**
   * Change token request.
   *
   * @returns {RequestOptions}
   */
  private getTokenPostOptions():RequestOptions {

    let headers = new Headers();
    headers.set('Accept', 'application/json');
    let options = new RequestOptions({
      headers: headers
    });

    return options;
  }
}


// WEBPACK FOOTER //
// ./admin/src/app/components/td-issues/td-issues.service.ts